// Globals
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// UI
import { CloseOutlined } from '@ant-design/icons';

// Locals
import styles from '../Components.module.css';
import { setGiideListFilter } from '../../actions';
import { IState } from '../../graphql/types';
import { Filters } from '../../types';
import { State } from '../utils';

// Types

interface IProps {
  text: string;
}

const FilterBox: React.FC<IProps> = ({ text }) => {
  const dispatch = useDispatch();
  const giideListFilter = useSelector<IState, Filters | undefined>(
    state => state.giideListFilter
  );

  const changeGiideListFilter = React.useCallback(() => {
    giideListFilter && console.log(giideListFilter[text]);
    if (giideListFilter)
      dispatch(
        setGiideListFilter({
          ...giideListFilter,
          [text]: false,
        })
      );
  }, [dispatch, giideListFilter, text]);

  return (
    <div className={styles.filterBox}>
      <span className={styles.filterBoxText}>{State[text]}</span>
      <CloseOutlined
        className={styles.filterBoxClose}
        onClick={() => changeGiideListFilter()}
      />
    </div>
  );
};

export default FilterBox;
